import { useLoggingQuery } from 'lib/apollo/apollo-hooks';

import { GET_STIMULUS_RESOURCE } from './stimulus.graphql';
import type {
  GetStimulusResourceQuery,
  GetStimulusResourceQueryVariables,
} from './stimulus.graphql.generated';

export const useGetStimulusResource = (
  id: number | undefined,
  isLoggedIn: boolean
) => {
  const { data, error, loading, refetch } = useLoggingQuery<
    GetStimulusResourceQuery,
    GetStimulusResourceQueryVariables
  >(
    GET_STIMULUS_RESOURCE,
    {
      variables: {
        input: {
          id: id!,
        },
      },
      skip: !id,
    },
    isLoggedIn
  );

  return { data, error, loading, refetch };
};
